<template>
  <div id="attendance" class="card-custom">
    <header>
      <nav class="align-items-center">
        <div class="title position-relative">
          <a :href="'#/overtime/'" class="navigation-text">Overtime {{title}}</a>
        </div>
        <ul class="header__navbar">
          <li class="header__item">
            <a class="header__link">
              <transition name="slide-fade">
                <button class="header--button m-1" v-if="show" key="on" @click="show = false">
                  <svg viewBox="0 0 24 24" class="header--icon">
                    <title>Close</title>
                    <path d="M0 0h24v24H0V0z" fill="none" />
                    <path
                      fill="currentColor"
                      d="M18.3 5.71c-.39-.39-1.02-.39-1.41 0L12 10.59 7.11 5.7c-.39-.39-1.02-.39-1.41 0-.39.39-.39 1.02 0 1.41L10.59 12 5.7 16.89c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0L12 13.41l4.89 4.89c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L13.41 12l4.89-4.89c.38-.38.38-1.02 0-1.4z"
                    />
                  </svg>
                </button>
                <button class="header--button m-1" v-else key="off" @click="show = true">
                   <svg xmlns="http://www.w3.org/2000/svg" x="120px" y="0px"
width="25" height="25"
viewBox="0 0 172 172"
style=" fill:#000000; margin-right: 12px;"><g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><path d="M0,172v-172h172v172z" fill="none"></path><g fill="#000000"><path d="M72.24,10.32c-32.26344,0 -58.48,26.21656 -58.48,58.48c0,32.26344 26.21656,58.48 58.48,58.48c12.76563,0 24.56375,-4.11187 34.185,-11.0725l45.2575,45.15l9.675,-9.675l-44.72,-44.8275c8.78813,-10.23937 14.0825,-23.52906 14.0825,-38.055c0,-32.26344 -26.21656,-58.48 -58.48,-58.48zM72.24,17.2c28.54125,0 51.6,23.05875 51.6,51.6c0,28.54125 -23.05875,51.6 -51.6,51.6c-28.54125,0 -51.6,-23.05875 -51.6,-51.6c0,-28.54125 23.05875,-51.6 51.6,-51.6z"></path></g></g></svg>
                </button>
              </transition>
            </a>
            <!-- filters -->
            <transition name="dropdown">
              <div class="dropdown__menu" v-bind:class="{ active: show }" v-if="show">
                <form class="mx-5">
                  <date-picker
                      v-model="filter.year"
                      @change="getOvertimeDataFilter()"
                      type="year"
                      placeholder="Search by Year"
                    >
                    </date-picker>
                </form>
              </div>
            </transition>
          </li>
        </ul>
      </nav>
    </header>
    <section class="chart-position">
      <apexchart type="bar" height="180" width="95%" :options="chartOptions" :series="series"></apexchart>
    </section>
  </div>
</template>

<script>
import Vue from 'vue';
import VueApexCharts from 'vue-apexcharts';
import DatePicker from 'vue2-datepicker';

Vue.use(VueApexCharts);
Vue.component('apexchart', VueApexCharts);
export default {
  name: 'pie-attendance',
  components: {DatePicker},
  data() {
    return {
      apiUrl : {
        overtimeChart: window.AppConfig.apiUrl + "new-dashboard"
      },
      title: this.$moment(new Date).format("YYYY"),
      filter: {
        year: null
      },
      show: false,
    //   seriesChart: [44, 55, 22],
      series: [],
     
      chartOptions: {
            chart: {
              type: 'bar',
              height: 350,
              stacked: true,
              toolbar: {
                show: false
              },

              zoom: {
                enabled: true
              }
            },
      
        dataLabels: {
          enabled: false,

        },
        stroke: {
          show: true,
          width: 1,
          colors: ['transparent'],
        },
         xaxis: {
          categories: [
            'Jan',
            'Feb',
            'Mar',
            'Apr',
            'May',
            'Jun',
            'Jul',
            'Aug',
            'Sep',
            'Oct',
            'Nov',
            'Dec',
          ],
        },

        yaxis: {
          title: {
            // text: "Hour",
          },
        },
        fill: {
          opacity: 1,
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return 'Total ' + val;
            },
          },
        },
        yearNow: new Date(),
        dataOvertime: []
      },
    };
  },
  watch: {
     "filter.year"(value){
      if(value !==null) this.getOvertimeDataFilter(value)
    }
  },
  mounted(){
    this.getOvertimeData()
  },

  methods: {
    async getOvertimeData() {
      const resp = await this.$http.get(this.apiUrl.overtimeChart + "?overtime_year=" +  this.$moment(new Date).format("YYYY"));
      this.dataOvertime = resp.data.overtime;
      this.series = [
        {
          name: 'Requested',
          data: [
            this.dataOvertime.Jan.requested !==null ? this.dataOvertime.Jan.requested : 0,
            this.dataOvertime.Feb.requested !==null ? this.dataOvertime.Feb.requested : 0,
            this.dataOvertime.Mar.requested !==null ? this.dataOvertime.Mar.requested : 0,
            this.dataOvertime.Apr.requested !==null ? this.dataOvertime.Apr.requested : 0,
            this.dataOvertime.May.requested !==null ? this.dataOvertime.May.requested : 0,
            this.dataOvertime.Jun.requested !==null ? this.dataOvertime.Jun.requested : 0,
            this.dataOvertime.Jul.requested !==null ? this.dataOvertime.Jul.requested : 0,
            this.dataOvertime.Aug.requested !==null ? this.dataOvertime.Aug.requested : 0,
            this.dataOvertime.Sep.requested !==null ? this.dataOvertime.Sep.requested : 0,
            this.dataOvertime.Oct.requested !==null ? this.dataOvertime.Oct.requested : 0,
            this.dataOvertime.Nov.requested !==null ? this.dataOvertime.Nov.requested : 0,
            this.dataOvertime.Dec.requested !==null ? this.dataOvertime.Dec.requested : 0,
          ]
        },
        {
          name: "Approved",
          data: [
            this.dataOvertime.Jan.approved !==null ? this.dataOvertime.Jan.approved : 0,
            this.dataOvertime.Feb.approved !==null ? this.dataOvertime.Feb.approved : 0,
            this.dataOvertime.Mar.approved !==null ? this.dataOvertime.Mar.approved : 0,
            this.dataOvertime.Apr.approved !==null ? this.dataOvertime.Apr.approved : 0,
            this.dataOvertime.May.approved !==null ? this.dataOvertime.May.approved : 0,
            this.dataOvertime.Jun.approved !==null ? this.dataOvertime.Jun.approved : 0,
            this.dataOvertime.Jul.approved !==null ? this.dataOvertime.Jul.approved : 0,
            this.dataOvertime.Aug.approved !==null ? this.dataOvertime.Aug.approved : 0,
            this.dataOvertime.Sep.approved !==null ? this.dataOvertime.Sep.approved : 0,
            this.dataOvertime.Oct.approved !==null ? this.dataOvertime.Oct.approved : 0,
            this.dataOvertime.Nov.approved !==null ? this.dataOvertime.Nov.approved : 0,
            this.dataOvertime.Dec.approved !==null ? this.dataOvertime.Dec.approved : 0,
          ]
        },
        {
          name: "Rejected",
          data: [
            this.dataOvertime.Jan.rejected !==null ? this.dataOvertime.Jan.rejected : 0,
            this.dataOvertime.Feb.rejected !==null ? this.dataOvertime.Feb.rejected : 0,
            this.dataOvertime.Mar.rejected !==null ? this.dataOvertime.Mar.rejected : 0,
            this.dataOvertime.Apr.rejected !==null ? this.dataOvertime.Apr.rejected : 0,
            this.dataOvertime.May.rejected !==null ? this.dataOvertime.May.rejected : 0,
            this.dataOvertime.Jun.rejected !==null ? this.dataOvertime.Jun.rejected : 0,
            this.dataOvertime.Jul.rejected !==null ? this.dataOvertime.Jul.rejected : 0,
            this.dataOvertime.Aug.rejected !==null ? this.dataOvertime.Aug.rejected : 0,
            this.dataOvertime.Sep.rejected !==null ? this.dataOvertime.Sep.rejected : 0,
            this.dataOvertime.Oct.rejected !==null ? this.dataOvertime.Oct.rejected : 0,
            this.dataOvertime.Nov.rejected !==null ? this.dataOvertime.Nov.rejected : 0,
            this.dataOvertime.Dec.rejected !==null ? this.dataOvertime.Dec.rejected : 0,
          ]
        },
        {
          name: "Canceled",
          data: [
            this.dataOvertime.Jan.canceled !==null ? this.dataOvertime.Jan.canceled : 0,
            this.dataOvertime.Feb.canceled !==null ? this.dataOvertime.Feb.canceled : 0,
            this.dataOvertime.Mar.canceled !==null ? this.dataOvertime.Mar.canceled : 0,
            this.dataOvertime.Apr.canceled !==null ? this.dataOvertime.Apr.canceled : 0,
            this.dataOvertime.May.canceled !==null ? this.dataOvertime.May.canceled : 0,
            this.dataOvertime.Jun.canceled !==null ? this.dataOvertime.Jun.canceled : 0,
            this.dataOvertime.Jul.canceled !==null ? this.dataOvertime.Jul.canceled : 0,
            this.dataOvertime.Aug.canceled !==null ? this.dataOvertime.Aug.canceled : 0,
            this.dataOvertime.Sep.canceled !==null ? this.dataOvertime.Sep.canceled : 0,
            this.dataOvertime.Oct.canceled !==null ? this.dataOvertime.Oct.canceled : 0,
            this.dataOvertime.Nov.canceled !==null ? this.dataOvertime.Nov.canceled : 0,
            this.dataOvertime.Dec.canceled !==null ? this.dataOvertime.Dec.canceled : 0,
          ]
        }
        ]

    },

     async getOvertimeDataFilter(value) {
      const resp = await this.$http.get(this.apiUrl.overtimeChart + "?overtime_year=" +  this.$moment(value).format("YYYY"));
      this.dataOvertime = resp.data.overtime;
      this.series = [
        {
          name: 'Requested',
          data: [
            this.dataOvertime.Jan.requested !==null ? this.dataOvertime.Jan.requested : 0,
            this.dataOvertime.Feb.requested !==null ? this.dataOvertime.Feb.requested : 0,
            this.dataOvertime.Mar.requested !==null ? this.dataOvertime.Mar.requested : 0,
            this.dataOvertime.Apr.requested !==null ? this.dataOvertime.Apr.requested : 0,
            this.dataOvertime.May.requested !==null ? this.dataOvertime.May.requested : 0,
            this.dataOvertime.Jun.requested !==null ? this.dataOvertime.Jun.requested : 0,
            this.dataOvertime.Jul.requested !==null ? this.dataOvertime.Jul.requested : 0,
            this.dataOvertime.Aug.requested !==null ? this.dataOvertime.Aug.requested : 0,
            this.dataOvertime.Sep.requested !==null ? this.dataOvertime.Sep.requested : 0,
            this.dataOvertime.Oct.requested !==null ? this.dataOvertime.Oct.requested : 0,
            this.dataOvertime.Nov.requested !==null ? this.dataOvertime.Nov.requested : 0,
            this.dataOvertime.Dec.requested !==null ? this.dataOvertime.Dec.requested : 0,
          ]
        },
        {
          name: "Approved",
          data: [
            this.dataOvertime.Jan.approved !==null ? this.dataOvertime.Jan.approved : 0,
            this.dataOvertime.Feb.approved !==null ? this.dataOvertime.Feb.approved : 0,
            this.dataOvertime.Mar.approved !==null ? this.dataOvertime.Mar.approved : 0,
            this.dataOvertime.Apr.approved !==null ? this.dataOvertime.Apr.approved : 0,
            this.dataOvertime.May.approved !==null ? this.dataOvertime.May.approved : 0,
            this.dataOvertime.Jun.approved !==null ? this.dataOvertime.Jun.approved : 0,
            this.dataOvertime.Jul.approved !==null ? this.dataOvertime.Jul.approved : 0,
            this.dataOvertime.Aug.approved !==null ? this.dataOvertime.Aug.approved : 0,
            this.dataOvertime.Sep.approved !==null ? this.dataOvertime.Sep.approved : 0,
            this.dataOvertime.Oct.approved !==null ? this.dataOvertime.Oct.approved : 0,
            this.dataOvertime.Nov.approved !==null ? this.dataOvertime.Nov.approved : 0,
            this.dataOvertime.Dec.approved !==null ? this.dataOvertime.Dec.approved : 0,
          ]
        },
        {
          name: "Rejected",
          data: [
            this.dataOvertime.Jan.rejected !==null ? this.dataOvertime.Jan.rejected : 0,
            this.dataOvertime.Feb.rejected !==null ? this.dataOvertime.Feb.rejected : 0,
            this.dataOvertime.Mar.rejected !==null ? this.dataOvertime.Mar.rejected : 0,
            this.dataOvertime.Apr.rejected !==null ? this.dataOvertime.Apr.rejected : 0,
            this.dataOvertime.May.rejected !==null ? this.dataOvertime.May.rejected : 0,
            this.dataOvertime.Jun.rejected !==null ? this.dataOvertime.Jun.rejected : 0,
            this.dataOvertime.Jul.rejected !==null ? this.dataOvertime.Jul.rejected : 0,
            this.dataOvertime.Aug.rejected !==null ? this.dataOvertime.Aug.rejected : 0,
            this.dataOvertime.Sep.rejected !==null ? this.dataOvertime.Sep.rejected : 0,
            this.dataOvertime.Oct.rejected !==null ? this.dataOvertime.Oct.rejected : 0,
            this.dataOvertime.Nov.rejected !==null ? this.dataOvertime.Nov.rejected : 0,
            this.dataOvertime.Dec.rejected !==null ? this.dataOvertime.Dec.rejected : 0,
          ]
        },
        {
          name: "Canceled",
          data: [
            this.dataOvertime.Jan.canceled !==null ? this.dataOvertime.Jan.canceled : 0,
            this.dataOvertime.Feb.canceled !==null ? this.dataOvertime.Feb.canceled : 0,
            this.dataOvertime.Mar.canceled !==null ? this.dataOvertime.Mar.canceled : 0,
            this.dataOvertime.Apr.canceled !==null ? this.dataOvertime.Apr.canceled : 0,
            this.dataOvertime.May.canceled !==null ? this.dataOvertime.May.canceled : 0,
            this.dataOvertime.Jun.canceled !==null ? this.dataOvertime.Jun.canceled : 0,
            this.dataOvertime.Jul.canceled !==null ? this.dataOvertime.Jul.canceled : 0,
            this.dataOvertime.Aug.canceled !==null ? this.dataOvertime.Aug.canceled : 0,
            this.dataOvertime.Sep.canceled !==null ? this.dataOvertime.Sep.canceled : 0,
            this.dataOvertime.Oct.canceled !==null ? this.dataOvertime.Oct.canceled : 0,
            this.dataOvertime.Nov.canceled !==null ? this.dataOvertime.Nov.canceled : 0,
            this.dataOvertime.Dec.canceled !==null ? this.dataOvertime.Dec.canceled : 0,
          ]
        }
        ]
        setTimeout(() => {
         this.title = this.$moment(value).format("YYYY")
          this.show = false
        }, 3000)

    }


  },
};
</script>

<style lang="scss">
#attendance {
  height: 40vh;
}
.chart-position {
  top: -78px;
  display: grid;
  position: static;
  bottom: 20px;
  left: 21px;
}
title {
  z-index: 1000;
}
ul,
li,
a {
  text-decoration: none !important;
}
.header {
  padding: 2rem 5rem 2rem 5rem;
  &__nav {
    position: relative;
  }
  &__navbar {
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
  &__item {
    padding: 1rem;
  }
  &--icon {
    width: 1.65rem;
    height: 1.65rem;
  }
  &--button {
    top: 0;
    right: 0;
    position: absolute;
    margin: 0;
    padding: 0;
    color: gray;
    cursor: pointer;
    border: 1px solid transparent;
    background-color: transparent;
    &:focus {
      outline: 0;
    }
  }
}
// Dropdown Menu

.dropdown__menu {
  right: 15%;
  top: 0;
  position: absolute;
  z-index: 10;
  height: 100%;
  min-width: 300px;
  //   margin-top: 0.5rem;
  overflow-y: auto;
  padding: 1rem 1rem 2rem 0rem;
  border-radius: 12px;
  background-color: white !important;
  //   background: #fff !important;
  border: 1px solid var(--color-gray);
  background-clip: padding-box;
  &-link {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    text-decoration: none;
    color: rgba(0, 0, 0, 0.6);
    padding: 0.8rem 0 0.8rem 2rem;
    margin-top: 0.2rem;
    margin-bottom: 0.2rem;
    border-radius: 0 50px 50px 0;
    &:hover {
      color: #17bf63;
      background-color: rgba(79, 192, 141, 0.1);
    }
  }
  &-svg {
    width: 1.5rem;
    height: 1.5rem;
  }
  &-text {
    font-weight: 300;
    margin-left: 1rem;
    margin-right: 1rem;
  }
}

// Animation Menu Icon

.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: all 0.6s;
}
.slide-fade-enter,
.slide-fade-leave-active {
  opacity: 0;
}
.slide-fade-enter {
  transform: translateX(31px);
}
.slide-fade-leave-active {
  transform: translateX(-31px);
}

// Dropdown Menu Animation

.dropdown-enter-active,
.dropdown-leave-active {
  transition: all 1s;
}
.dropdown-enter,
.dropdown-leave-to {
  opacity: 0;
  transform: translateY(30px);
}
</style>